export default __webpack_public_path__ + "static/media/linkedinf.acddf097.svg";